export default "assets/logo-black_old-03000cfe.png";